import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
    Grid,
    Typography,
    Container,
    TextField,
    Button,
    Alert,
    IconButton,
    Autocomplete,
    RadioGroup, 
    Radio, 
    FormControlLabel,
    Divider,
    FormControl,
    CircularProgress,
    Checkbox,
    Box,
    Select, 
    MenuItem, 
    InputLabel,
} from '@mui/material';
import OneTimeBroadcast from './BroadcastTypes/OneTimeBroadcast';
import RecurringBroadcast from './BroadcastTypes/RecurringBroadcast';
import DeleteIcon from '@mui/icons-material/Delete';
import MessageNode from "../Whatsapp/MessageNode";
import { TEMPLATE_ENDPOINT, TEMPLATE_BROADCAST_ENDPOINT, CAMPAIGN_LIST_ENDPOINT } from '../../config/urls';
import UploadCSV from './CampaignOptions/UploadCSV';
import SingleContact from './CampaignOptions/SingleContact';
import SelectSegment from './CampaignOptions/SelectSegment';
import axios from 'axios';
import { useAuth } from '../../hooks/AuthProvider';

const BroadcastTemplates = (props) => {
    const { getValidToken } = useAuth();
    const [selectedTemplate, setSelectedTemplate] = useState('');
    const [templateOptions, setTemplateOptions] = useState([]);
    const [templateData, setTemplateData] = useState(null);
    const [templatePreviewData, setTemplatePreviewData] = useState(null);
    const [apiData, setApiData] = useState(null);
    const [requiredFields, setRequiredFields] = useState({});
    const fileInputRef = useRef(null);
    const [mediaType, setMediaType] = useState('none');
    const [mediaFile, setMediaFile] = useState(null);
    const [requiredFieldsToRender, setRequiredFieldsToRender] = useState([]);
    const [formValues, setFormValues] = useState({});
    const [showCampaignOptions, setShowCampaignOptions] = useState(false);
    const [selectedCampaign, setSelectedCampaign] = useState('');
    const [campaignsData, setCampaignsData] = useState([]);
    const [csvFile, setCsvFile] = useState(null);
    const [campaignName, setCampaignName] = useState('');
    const [campaignDescription, setCampaignDescription] = useState('');
    const [selectedSegment, setSelectedSegment] = useState('Select a segment');
    const [selectedSegmentList, setSelectedSegmentList] = useState([]);
    const [phoneNumberCount, setPhoneNumberCount] = useState(0);
    const [countryCode, setCountryCode] = useState('');
    const [dialCode, setDialCode] = useState('');
    const [alertObj, setAlertObj] = useState({ active: false, msg: "", type: "" });
    const [csvError, setCSVError] = useState(null);
    const [showAllErrors, setShowAllErrors] = useState(false);
    const [loading, setLoading] = useState(false);

    const [showTemplateSelection, setShowTemplateSelection] = useState(false);
    const [broadcastType, setBroadcastType] = useState('now'); // 'now', 'one-time', or 'recurring'
    const [scheduleDate, setScheduleDate] = useState('');
    const [broadcastTime, setBroadcastTime] = useState('');
    const [notifyBefore, setNotifyBefore] = useState(true);
    const [notifyStatus, setNotifyStatus] = useState(true);

    const [categoryFilter, setCategoryFilter] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');

    const [templateTracking, setTemplateTracking] = useState(false);
    const [recurringData, setRecurringData] = useState({});
    // Add this state near your other useState hooks
    // const [paramTypes, setParamTypes] = useState({});

    const [formErrors, setFormErrors] = useState({
        latitude: false,
        longitude: false
    });

    const handleAlertClose = () => setAlertObj({ active: false, type: "", msg: "" });
    const selectOptions = ['name', 'age', 'gender', 'city', 'email', 'custom'];

    // State to track carousel media files
    const [carouselMediaFiles, setCarouselMediaFiles] = useState({});
    const carouselFileInputRefs = useRef({});
    const [carouselFileDisplays, setCarouselFileDisplays] = useState({});
    const [cardType, setCardType] = useState('');

    const [mediaFileError, setMediaFileError] = useState(false);
    const [carouselFileErrors, setCarouselFileErrors] = useState({});
    
    // State to track card index - '-1' means no card
    const [cardIndex, setCardIndex] = useState(-1);
    
    useEffect(() => {        
        if(selectedCampaign === "option3"){
            setFirstName("N/A")
            setLastName("N/A")
        }
    }, [selectedCampaign])

    const CarouselFileDisplay = ({ cardIndex, file, onDelete, fileError }) => {
        const hasError = carouselFileErrors[cardIndex];
        
        if (!file && !fileError) return null;
        
        return (
            <Grid container direction="column" spacing={1} sx={{ mt: 1 }}>
                {/* Display file validation error */}
                {fileError && (
                    <Grid item>
                        <Typography 
                            variant="body2" 
                            color="error" 
                            sx={{ display: 'block' }}
                        >
                            {fileError}
                        </Typography>
                    </Grid>
                )}
                
                {/* Display file info if uploaded */}
                {file && (
                    <Grid item>
                        <Grid container alignItems="center" spacing={1}>
                            <Grid item>
                                <Typography variant="body2">
                                    File uploaded: {file.name}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <IconButton
                                    aria-label="delete"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        onDelete(cardIndex);
                                    }}
                                    size="small"
                                    type="button"
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        );
    };

    const CarouselFileDisplayContainer = ({ carouselMediaFiles, onDelete }) => {
        // Force re-render when carouselMediaFiles changes
        const [, forceRender] = useState({});
        
        useEffect(() => {
            // Force a re-render when carouselMediaFiles changes
            forceRender({});
        }, [carouselMediaFiles]);
        
        return (
        <>
            {Object.entries(carouselMediaFiles).map(([cardIndex, file]) => (
            <div key={`file-display-${cardIndex}`} id={`carousel-file-display-content-${cardIndex}`}>
                <CarouselFileDisplay
                cardIndex={parseInt(cardIndex)}
                file={file}
                onDelete={onDelete}
                />
            </div>
            ))}
        </>
        );
    };

    // Function to generate file input for carousel cards
    const getCarouselFileInput = (type, cardIndex) => {
        console.log("---------------------Invoked getCarouselFileInput");

        console.log("formValues in getCarouselFileInput: ", formValues);
        
        const fileTypes = {
            image: {
                accept: '.jpg, .png',
                label: 'Choose .JPG or .PNG *',
            },
            video: {
                accept: '.mp4',
                label: 'Choose .MP4 file *',
            },
            document: {
                accept: '.pdf',
                label: 'Choose .PDF file *',
            },
        };
    
        if (fileTypes[type]) {
            const { accept, label } = fileTypes[type];
            const inputId = `carousel-file-upload-${cardIndex}`;
            
            return (
                <Grid container direction="column" spacing={2}>
                    <Grid item>
                        <input
                            ref={el => carouselFileInputRefs.current[cardIndex] = el}
                            id={inputId}
                            name={`carousel-file-${cardIndex}`}
                            type="file"
                            accept={accept}
                            onChange={(e) => handleCarouselMediaFileChange(e, cardIndex)}
                            style={{ display: 'none' }}
                            required
                        />
                        <label htmlFor={inputId}>
                            <Button
                                variant="contained"
                                component="span"
                                sx={{ marginTop: 1, marginBottom: 1 }}
                                type="button"
                            >
                                {label}
                            </Button>
                        </label>
                    </Grid>
                </Grid>
            );
        }
        return null;
    };    

    const renderCarouselFileDisplay = (cardIndex) => {
        console.log("carouselFileErrors: ", carouselFileErrors);

        return (
            <CarouselFileDisplay 
                file={carouselMediaFiles[cardIndex]} 
                cardIndex={cardIndex} 
                onDelete={handleDeleteCarouselMediaFile} 
                fileError={carouselFileErrors[cardIndex]} // Pass the error to the component
            />
        );
    };

    // Function to handle carousel media file change
    const handleCarouselMediaFileChange = (event, cardIndex) => {
        event.preventDefault();

        const file = event.target.files[0];
        if (!file) return;

        // File type validation for carousel files
        let allowedTypes = [];
        const inputAccept = event.target.accept;
        if (inputAccept.includes('mp4')) {
            allowedTypes = ['video/mp4'];
        } else if (inputAccept.includes('pdf')) {
            allowedTypes = ['application/pdf'];
        } else {
            allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        }

        if (allowedTypes.length && !allowedTypes.includes(file.type)) {
            let typeMsg = '';
            if (allowedTypes[0] === 'video/mp4') typeMsg = 'video (.mp4)';
            else if (allowedTypes[0] === 'application/pdf') typeMsg = 'PDF (.pdf)';
            else typeMsg = 'image (.jpg, .jpeg, .png)';
            setCarouselFileErrors(prev => ({
                ...prev,
                [cardIndex]: `Invalid file type. Please upload a ${typeMsg} file.`
            }));
            event.target.value = '';
            return;
        }

        // File size validation for carousel files
        const maxSizes = {
            'video/mp4': 16 * 1024 * 1024, // 16MB for videos
            'image/jpeg': 5 * 1024 * 1024, // 5MB for images
            'image/jpg': 5 * 1024 * 1024,  // 5MB for images
            'image/png': 5 * 1024 * 1024,  // 5MB for images
            'application/pdf': 5 * 1024 * 1024 // 5MB for pdf
        };

        const maxSize = maxSizes[file.type];
        if (maxSize && file.size > maxSize) {
            const sizeLimit = file.type === 'video/mp4' ? '16MB' : '5MB';
            const fileType = file.type === 'video/mp4' ? 'video' : (file.type === 'application/pdf' ? 'PDF' : 'image');
            setCarouselFileErrors(prev => ({
                ...prev,
                [cardIndex]: `File size exceeds the limit of ${sizeLimit} for ${fileType} files.`
            }));
            event.target.value = '';
            return;
        }

        // Clear any previous file errors for this card and set the file
        setCarouselFileErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors[cardIndex];
            return newErrors;
        });

        setCarouselMediaFiles(prev => ({
            ...prev,
            [cardIndex]: file
        }));
    };

    // Function to delete carousel media file
    const handleDeleteCarouselMediaFile = (cardIndex) => {
        // Clear file error for this card when file is deleted
        setCarouselFileErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors[cardIndex];
            return newErrors;
        });
        
        // Create a new object to ensure React detects the state change
        setCarouselMediaFiles(prev => {
            const newFiles = { ...prev };
            delete newFiles[cardIndex];
            return newFiles;
        });
        
        // Reset the file input
        if (carouselFileInputRefs.current[cardIndex]) {
            carouselFileInputRefs.current[cardIndex].value = '';
        }
    };

    const handleMediaFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // File type validation
        let allowedTypes = [];
        if (mediaType === 'image') {
            allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        } else if (mediaType === 'video') {
            allowedTypes = ['video/mp4'];
        } else if (mediaType === 'document') {
            allowedTypes = ['application/pdf'];
        }

        if (allowedTypes.length && !allowedTypes.includes(file.type)) {
            let typeMsg = '';
            if (mediaType === 'image') typeMsg = 'image (.jpg, .jpeg, .png)';
            else if (mediaType === 'video') typeMsg = 'video (.mp4)';
            else if (mediaType === 'document') typeMsg = 'PDF (.pdf)';
            setMediaFileError(`Invalid file type. Please upload a ${typeMsg} file.`);
            event.target.value = '';
            return;
        }

        // File size validation
        const maxSizes = {
            'video/mp4': 16 * 1024 * 1024, // 16MB for videos
            'image/jpeg': 5 * 1024 * 1024, // 5MB for images
            'image/jpg': 5 * 1024 * 1024,  // 5MB for images
            'image/png': 5 * 1024 * 1024,  // 5MB for images
            'application/pdf': 100 * 1024 * 1024 // 100MB for PDFs
        };

        const maxSize = maxSizes[file.type];
        if (maxSize && file.size > maxSize) {
            const sizeLimit = file.type === 'video/mp4' ? '16MB' : 
                            file.type === 'application/pdf' ? '100MB' : '5MB';
            const fileType = file.type === 'video/mp4' ? 'video' : 
                            file.type === 'application/pdf' ? 'document' : 'image';
            setMediaFileError(`File size exceeds the limit of ${sizeLimit} for ${fileType} files.`);
            event.target.value = '';
            return;
        }

        // Clear any previous file errors and set the file
        setMediaFileError(false);
        setMediaFile(file);
    };

    const handleDeleteMediaFile = () => {
        setMediaFileError(false); // Clear media file error when file is deleted
        setMediaFile(null);
        if (fileInputRef.current) fileInputRef.current.value = '';
        handleTemplateChange({ target: { value: selectedTemplate || '' } });
    };

    const handleCategoryFilterChange = (event) => {
    const newCategory = event.target.value;

    // If the user switched from marketing <-> utility
    if (newCategory !== categoryFilter) {
        // 1. Reset all form-related state
        resetForm();                           // Clears formValues, files, media, etc.
        setAlertObj({ active: false, msg: "", type: "" });
        setShowTemplateSelection(false);       // Hide template section until "Next" is clicked
        setSelectedTemplate('');               // Clear previously selected template
        setTemplateData(null);                 // Clear raw template data
        setTemplatePreviewData(null);          // Clear preview
        setRequiredFieldsToRender([]);         // Clear rendered param fields
    }

    // Finally update the selected category
    setCategoryFilter(newCategory);
    };


    const fetchTemplatesData = useCallback(async () => {
        const token = await getValidToken();
        const tenant = localStorage.getItem('tenant');
        try {
            const response = await fetch(`${TEMPLATE_ENDPOINT}?category_filter=${categoryFilter}&limit=1000`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    "Content-Type": "application/json",
                    "X-Tenant-Id": tenant
                }
            });
            if (!response.ok) throw new Error('Failed to fetch templates data');
            const jsonData = await response.json();
            const approvedTemplates = {
                ...jsonData,
                results: jsonData.results.filter(template => template.status === 'APPROVED' && template.active)
            };
            setApiData(approvedTemplates);
            setTemplateOptions(approvedTemplates.results.map(item => item.template_name));
            setRequiredFields(approvedTemplates.required_fields);
        } catch (error) {
            console.error('Error fetching templates data:', error.message);
        }
    }, [getValidToken, categoryFilter]);

    const fetchCampaignsData = useCallback(async () => {
        const token = await getValidToken();
        const tenant = localStorage.getItem('tenant');
        try {
            const response = await fetch(`${CAMPAIGN_LIST_ENDPOINT}?limit=1000`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    "Content-Type": "application/json",
                    "X-Tenant-Id": tenant   
                }
            });
            if (!response.ok) throw new Error('Failed to fetch campaigns data');
            const jsonData = await response.json();
            const campaignNames = jsonData.results.map(campaign => campaign.campaign_name.toLowerCase());
            setCampaignsData(campaignNames);
        } catch (error) {
            console.error('Error fetching campaigns data:', error.message);
        }
    }, [getValidToken]);

    const handleTemplateChange = (event) => {
        const selectedTemplateName = event.target.value;

        resetForm(); // Reset form values and state before setting new template

        setAlertObj({ active: false, msg: "", type: "" });
        setSelectedTemplate(selectedTemplateName);

        if (selectedTemplateName !== '') {
            const selectedTemplate = apiData?.results.find(item => item.template_name === selectedTemplateName);
            if (selectedTemplate) {
                setTemplatePreviewData(selectedTemplate.template_preview_json);
                setTemplateData(selectedTemplate.template_json);
                
                // Don't call resetForm() here - it wipes out existing values
                // Instead, just update the mediaType without resetting all values
                setMediaType('none');
                // And then populate the fields for the new template
                updateRequiredFields(selectedTemplateName);
            }
        }
    };

    const resetForm = () => {
        setFormValues(prevValues => {
            // Create a new object with only non-template specific values
            const persistentValues = {};
            // Specify which values to preserve if needed
            // e.g., campaign info, user info, etc.
            
            // Return a clean slate for template-specific values
            return persistentValues;
        });
        setRequiredFieldsToRender([]);
        setMediaType('none');
        setMediaFile(null);
        setMediaFileError(false); // Clear media file errors
        setCarouselFileErrors({}); // Clear carousel file errors
        if (fileInputRef.current) fileInputRef.current.value = '';
        setCarouselMediaFiles({});
    };

    // HANDLE BROADCAST TYPE CHANGE
    const handleBroadcastTypeChange = (event) => {
        setBroadcastType(event.target.value);
        // Reset scheduling fields when changing broadcast type
        if (event.target.value === 'now') {
            setCsvFile(null);
            setCountryCode('');
            setDialCode('');
            setFirstName('');
            setLastName('');
            setCampaignName('');
            setCampaignDescription('');
            setSelectedSegment('Select a segment');
            setSelectedSegmentList([]);
            setPhoneNumberCount(0);
        }

        if (event.target.value !== 'one-time') {
            setScheduleDate('');
            setBroadcastTime('');
        }
    };

    // HANDLE CANCEL
    const handleCancelSchedule = () => {
        // setScheduleDate('');
        // setBroadcastTime('');
        // setCountryCode('');
        // setDialCode('');
        // setFirstName('sdffdfdsssssssss');
        // setLastName('');
        // setCampaignName('');
        // setCampaignDescription('');
        // setSelectedSegment('');
        // setSelectedSegmentList([]);
        // setPhoneNumberList([]);
        setBroadcastType('now');
        setScheduleDate('');
        setBroadcastTime('');
        setCountryCode('');
        setDialCode('');
        setFirstName('');
        setLastName('');
        setCampaignName('');
        setCampaignDescription('');
        setSelectedSegment('Select a segment');
        setSelectedSegmentList([]);
        setPhoneNumberCount(0);
    };

    const updateRequiredFields = (templateName) => {
        const requiredFieldsForTemplate = requiredFields[templateName];
        if (requiredFieldsForTemplate) {
            const fieldsToRender = [];
            
            // First pass: identify if we have carousel parameters and organize them by card
            const isCarousel = requiredFieldsForTemplate.some(field => 
                field.startsWith('cardimage') || field.startsWith('cardvideo') || field.startsWith('cardbody'));

            const updatedFormValues = { ...formValues };
    
            if (isCarousel) {
                console.log("Carousel template detected - preserving form values:", updatedFormValues);
            }
    
            // Helper function to extract card index from parameter name
            const getCardIndex = (fieldName) => {
                const matches = fieldName.match(/_(\d+)$/);
                return matches ? parseInt(matches[1]) : null;
            };
    
            
            // Group parameters by card index for carousel templates
            const cardParams = {};
            if (isCarousel) {
                requiredFieldsForTemplate.forEach(field => {
                    const cardIndex = getCardIndex(field);
                    if (cardIndex !== null) {
                        if (!cardParams[cardIndex]) {
                            cardParams[cardIndex] = [];
                        }
                        cardParams[cardIndex].push(field);
                    }
                });
            }
    
            const fieldHandlers = {
                hparameter: () => {
                    const paramType = formValues.param_types?.hparameter?.param_type || "custom";
                    fieldsToRender.push(
                        <Grid container direction="row" spacing={2} key="hparameter" sx={{ marginBottom: 2 }}>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <InputLabel id="header-param-label">Header Parameter Type</InputLabel>
                                    <Select
                                        name="hparameter_select"
                                        value={paramType}
                                        labelId="header-param-label"
                                        label="Header Parameter Type"
                                        onChange={e => handleSelectParamTypeChange("hparameter", e.target.value)}
                                    >
                                        {selectOptions.map(option => (
                                            <MenuItem key={option} value={option}>{option.toUpperCase()}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                {paramType === "custom" && (
                                    <TextField
                                        fullWidth
                                        label="Enter Value"
                                        name="hparameter"
                                        onChange={handleInputChange}
                                        required
                                    />
                                )}
                            </Grid>
                        </Grid>
                    );
                    // No need to set updatedFormValues.hparameter here, as formValues will be managed by handlers
                },
                bparameter: () => {
                    const bparameterCount = requiredFieldsForTemplate.filter(field => field === 'bparameter').length;
                    // console.log("bparameterCount: ", bparameterCount);

                    // flush fieldsToRender before adding new ones
                    // fieldsToRender.length = 0;      // TODO: Debug for root cause - If body has 2 placeholders, 4 textfields are displayed - This is a temporary solution

                    for (let i = 0; i < bparameterCount; i++) {
                        // IMPORTANT: Use consistent parameter naming format without hyphen
                        // Change from 'bparameter-${i}' to 'bparameter_${i}' for consistency
                        const fieldName = `bparameter_${i}`;
                        const paramType = updatedFormValues.param_types?.[fieldName]?.param_type || "";

                        console.log("ParamType: ", paramType);

                        fieldsToRender.push(
                            <Grid container direction="row" spacing={2} key={fieldName} sx={{ marginBottom: 2 }}>
                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                    <InputLabel id={`main-body-param-label-${i+1}`}>{`Main Body Parameter ${i + 1}`}</InputLabel>
                                    <Select 
                                        name={`${fieldName}_select`} 
                                        // defaultValue="custom"
                                        // value={paramType}
                                        labelId={`main-body-param-label-${i+1}`}
                                        label={`Main Body Parameter ${i + 1}`} 
                                        onChange={e => handleSelectParamTypeChange(fieldName, e.target.value)}
                                        >
                                        {selectOptions.map(option => (
                                            <MenuItem key={option} value={option}>{option.toUpperCase()}</MenuItem>
                                        ))}
                                    </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>                            
                                    {paramType === "custom" && 
                                        <TextField 
                                            fullWidth
                                            label={`${paramType}`} 
                                            name={fieldName} 
                                            onChange={handleInputChange} 
                                            // required={paramTypes[fieldName] === "custom"}
                                            // disabled={paramType !== "custom"}
                                            // value={formValues[fieldName] || ""}
                                            // value={formValues[fieldName] || ""}
                                        />
                                    }
                                </Grid>
                            </Grid>
                        );
                        // updatedFormValues[fieldName] = '';
                    }
                },
                urlparameter: () => {
                    const urlParamterCount = requiredFieldsForTemplate.filter(field => field === 'urlparameter').length;
                    
                    for (let i = 0; i < urlParamterCount; i++) {
                        fieldsToRender.push(
                            <Grid container direction="column" key={`urlparameter_${i}`} sx={{ marginBottom: 2, width: '50%' }}>
                                <TextField key={`urlparameter_${i}`} label="URL Parameter" name={`urlparameter_${i}`} onChange={handleInputChange} required />
                            </Grid>
                        );
                    }   
                    updatedFormValues.urlparameter = '';
                },
                imageparameter: () => {
                    setMediaType('image');
                    fieldsToRender.push(getFileInput('image'));
                    updatedFormValues.imageparameter = '';
                },
                videoparameter: () => {
                    setMediaType('video');
                    fieldsToRender.push(getFileInput('video'));
                    updatedFormValues.videoparameter = '';
                },
                documentparameter: () => {
                    setMediaType('document');
                    fieldsToRender.push(getFileInput('document'));
                    updatedFormValues.documentparameter = '';
                },
                locationparameter: () => {
                    fieldsToRender.push(
                        <>
                            <Grid container direction="column" key="locationparameter_name" sx={{ marginBottom: 2, width: '50%' }}>
                                <TextField key="locationparameter_name" label="Location Name" name='locationparameter_name' onChange={handleInputChange} required />
                            </Grid>
                            <Grid container direction="column" key="locationparameter_address" sx={{ marginBottom: 2, width: '50%' }}>
                                <TextField key="locationparameter_address" label="Location Address" name='locationparameter_address' onChange={handleInputChange} required />
                            </Grid>
                            <Grid container direction="column" key="locationparameter_latitude" sx={{ marginBottom: 2, width: '50%' }}>
                                <TextField key="locationparameter_latitude" type="number" inputProps={{step: "0.000001", min: -90, max: 90}} label="Location Latitude" name='locationparameter_latitude' onChange={handleInputChange} required error={formErrors.latitude} helperText={formErrors.latitude ? "Latitude must be between -90 and 90" : ""}/>
                            </Grid>
                            <Grid container direction="column" key="locationparameter_longitude" sx={{ marginBottom: 2, width: '50%' }}>
                                <TextField key="locationparameter_longitude" type="number" inputProps={{step: "0.000001", min: -180, max: 180}} label="Location Longitude" name='locationparameter_longitude' onChange={handleInputChange} required error={formErrors.longitude} helperText={formErrors.longitude ? "Longitude must be between -180 and 180" : ""}/>
                            </Grid>
                        </>
                    );
                    updatedFormValues.locationparameter_name = '';
                    updatedFormValues.locationparameter_address = '';
                    updatedFormValues.locationparameter_latitude = '';
                    updatedFormValues.locationparameter_longitude = '';
                },
                // Add handlers for carousel parameters
                cardimageparameter: (cardIndex) => {
                    // Create a file input for card image
                    const fieldName = `cardimageparameter_${cardIndex}`;
                    fieldsToRender.push(
                        <Grid container direction="column" key={`${fieldName}-${JSON.stringify(carouselFileErrors)}`} sx={{ marginBottom: 2 }}>
                            <Typography variant="subtitle1">Card {cardIndex + 1} Image</Typography>
                            {getCarouselFileInput('image', cardIndex)}
                            <CarouselFileDisplay 
                                file={carouselMediaFiles[cardIndex]} 
                                cardIndex={cardIndex} 
                                onDelete={handleDeleteCarouselMediaFile} 
                                fileError={carouselFileErrors[cardIndex]}
                            />
                        </Grid>
                    );
                    updatedFormValues[fieldName] = '';
                },
                cardvideoparameter: (cardIndex) => {
                    // Create a file input for card video
                    const fieldName = `cardvideoparameter_${cardIndex}`;
                    fieldsToRender.push(
                        <Grid container direction="column" key={`${fieldName}-${JSON.stringify(carouselFileErrors)}`} sx={{ marginBottom: 2 }}>
                            <Typography variant="subtitle1">Card {cardIndex + 1} Video</Typography>
                            {getCarouselFileInput('video', cardIndex)}
                            <CarouselFileDisplay 
                                file={carouselMediaFiles[cardIndex]} 
                                cardIndex={cardIndex} 
                                onDelete={handleDeleteCarouselMediaFile} 
                                fileError={carouselFileErrors[cardIndex]}
                            />
                        </Grid>
                    );
                    updatedFormValues[fieldName] = '';
                },
                cardbodyparameter: (cardIndex, cardFieldIndex) => {
                    // IMPORTANT: Make sure the field name follows the correct format for the API
                    const fieldName = `cardbodyparameter_${cardIndex}_${cardFieldIndex}`;

                    fieldsToRender.push(
                        <Grid container direction="column" key={fieldName} sx={{ marginBottom: 2, width: '50%' }}>
                            <TextField 
                                key={fieldName} 
                                label={`Card ${parseInt(cardIndex) + 1} Body Parameter ${cardFieldIndex}`} 
                                name={fieldName} 
                                onChange={handleInputChange} 
                                required 
                            />
                        </Grid>
                    );
                    // updatedFormValues[fieldName] = '';
                    
                },
                cardurlparameter: (cardIndex) => {
                    // Create a text field for card URL parameter
                    const fieldName = `cardurlparameter_${cardIndex}`;
                    fieldsToRender.push(
                        <Grid container direction="column" key={fieldName} sx={{ marginBottom: 2, width: '50%' }}>
                            <TextField 
                                key={fieldName} 
                                label={`Card ${cardIndex + 1} URL Parameter`} 
                                name={fieldName} 
                                onChange={handleInputChange} 
                                required 
                            />
                        </Grid>
                    );
                    // updatedFormValues[fieldName] = '';
                }
            };

            console.log("fieldsToRender: ", fieldsToRender);
    
            // Handle non-carousel parameters first
            let standardFields = requiredFieldsForTemplate.filter(field => 
                !field.startsWith('cardimage') && 
                !field.startsWith('cardvideo') && 
                !field.startsWith('cardbody') &&
                !field.startsWith('cardurl')
            );

            // Remove duplicate 'bparameter' entries if they exist
            standardFields = standardFields.filter((value, index, array) => value !== 'bparameter' || array.indexOf(value) === index);
            
            // Remove duplicate 'urlparameter' entries if they exist
            standardFields = standardFields.filter((value, index, array) => value !== 'urlparameter' || array.indexOf(value) === index);
            
            // Remove duplicate 'cardbodyparameter' entries if they exist
            standardFields = standardFields.filter((value, index, array) => value !== 'cardbodyparameter' || array.indexOf(value) === index);
            
            // Move 'hparameter' to the start
            const moveToStart = (arr, value) => {
                if(arr.includes(value)) {
                    return [value, ...arr.filter(v => v !== value)];
                }
                return arr;
            };
            standardFields = moveToStart(standardFields, 'hparameter'); 

            standardFields.forEach(field => {
                if (fieldHandlers[field]) fieldHandlers[field]();
            });
            
            // Then handle carousel parameters organized by card
            if (isCarousel) {
                // Add a section header for carousel parameters
                fieldsToRender.push(
                    <Typography variant="h6" key="carousel-header" sx={{ marginTop: 2, marginBottom: 1 }}>
                        Carousel Cards Parameters
                    </Typography>
                );
                
                // Process parameters for each card
                Object.keys(cardParams).sort((a, b) => parseInt(a) - parseInt(b)).forEach(cardIndex => {
                    const cardFields = cardParams[cardIndex];
                    
                    // Add a divider and card title
                    fieldsToRender.push(
                        <>
                            <Divider key={`divider-${cardIndex}`} sx={{ width: '100%', my: 2 }} />
                        </>
                    );
                    fieldsToRender.push(
                        <Typography variant="h6" key={`card-title-${cardIndex}`} sx={{ marginBottom: 1 }}>
                            Card {parseInt(cardIndex) + 1}
                        </Typography>
                    );
                    
                    // Process each parameter type for this card
                    cardFields.forEach((field, cardFieldIndex) => {
                        if (field.startsWith('cardimageparameter')) {
                            fieldHandlers.cardimageparameter(parseInt(cardIndex));
                        } else if (field.startsWith('cardvideoparameter')) {
                            fieldHandlers.cardvideoparameter(parseInt(cardIndex));
                        } else if (field.startsWith('cardbodyparameter')) {
                            fieldHandlers.cardbodyparameter(parseInt(cardIndex), cardFieldIndex);
                        } else if (field.startsWith('cardurlparameter')) {
                            fieldHandlers.cardurlparameter(parseInt(cardIndex));
                        }
                    });
                });
            }

            // >>> ADD THIS BLOCK HERE, before setFormValues <<<
            const paramTypesInit = { ...(formValues.param_types || {}) };
            requiredFieldsForTemplate.forEach((field, idx) => {
                if (field === 'bparameter') {
                    const fname = `bparameter_${idx}`;
                    if (!paramTypesInit[fname]) {
                        paramTypesInit[fname] = { name: fname, param_type: "", value: "" };
                    }
                }
                if (field === 'hparameter') {
                    if (!paramTypesInit.hparameter) {
                        paramTypesInit.hparameter = { name: "hparameter", param_type: "custom", value: "" };
                    }
                }
                // Add similar logic for other dynamic param types if needed
            });
            updatedFormValues.param_types = paramTypesInit;
            // <<< END BLOCK >>>
    
            setFormValues(prevValues => ({
                ...prevValues,
                ...updatedFormValues
            }));
            setRequiredFieldsToRender(fieldsToRender);

            console.log("formValues in updateRequiredFields: ", JSON.stringify(formValues, 0, 2));
        } else {
            console.log("Resetting form values");
            resetForm();
        }
    };

    // const handleSelectParamTypeChange = (fieldName, value) => {
    //     setParamTypes(prev => ({
    //         ...prev,
    //         [fieldName]: value
    //     }));

    //     setFormValues(prev => {
    //         // If switching to custom, preserve previous value (don't clear)
    //         // If switching away from custom, set value to the selected type
    //         const newValue = value === "custom" ? (prev[fieldName] || "") : value;
    //         return {
    //         ...prev,
    //         [fieldName]: newValue,
    //         param_types: {
    //             ...(prev.param_types || {}),
    //             [fieldName]: {
    //             name: fieldName,
    //             param_type: value,
    //             value: newValue
    //             }
    //         }
    //         };
    //     });
    // };

    const handleSelectParamTypeChange = (fieldName, value) => {
        setFormValues(prev => {
            const updatedParamTypes = {
                ...(prev.param_types || {}),
                [fieldName]: {
                    name: fieldName,
                    param_type: value,
                    value: value === "custom" ? "" : value
                }
            };

            return {
                ...prev,
                [fieldName]: updatedParamTypes[fieldName].value,
                param_types: updatedParamTypes
            };
        });

        // Update the requiredFieldsToRender to reflect the change (Pervious Change )
        // setRequiredFieldsToRender(prevFields => {
        //     return prevFields.map(field => {
        //         // Check if this is the field we need to update
        //         if (field.key === fieldName) {
        //             // Recreate the field with the updated param type
        //             const paramType = value;
                    
        //             return (
        //                 <Grid container direction="row" spacing={2} key={fieldName} sx={{ marginBottom: 2 }}>
        //                     <Grid item xs={6}>
        //                         <FormControl fullWidth>
        //                             <InputLabel id={`main-body-param-label-${fieldName.split('_')[1]}`}>
        //                                 {`Main Body Parameter ${parseInt(fieldName.split('_')[1]) + 1}`}
        //                             </InputLabel>
        //                             <Select 
        //                                 name={`${fieldName}_select`}
        //                                 labelId={`main-body-param-label-${fieldName.split('_')[1]}`}
        //                                 label={`Main Body Parameter ${parseInt(fieldName.split('_')[1]) + 1}`}
        //                                 value={value}
        //                                 onChange={e => handleSelectParamTypeChange(fieldName, e.target.value)}
        //                             >
        //                                 {selectOptions.map(option => (
        //                                     <MenuItem key={option} value={option}>{option.toUpperCase()}</MenuItem>
        //                                 ))}
        //                             </Select>
        //                         </FormControl>
        //                     </Grid>
        //                     <Grid item xs={6}>
        //                         {paramType === "custom" && 
        //                             <TextField 
        //                                 fullWidth
        //                                 label={"Value"} 
        //                                 name={fieldName} 
        //                                 onChange={handleInputChange} 
        //                             />
        //                         }
        //                     </Grid>
        //                 </Grid>
        //             );
        //         }
        //         return field;
        //     });
        // });

        setRequiredFieldsToRender(prevFields => {
                return prevFields.map(field => {
                    // For body parameters
                    if (field.key && field.key.startsWith('bparameter_') && field.key === fieldName) {
                        const paramType = value;
                        const idx = parseInt(fieldName.split('_')[1]);
                        return (
                            <Grid container direction="row" spacing={2} key={fieldName} sx={{ marginBottom: 2 }}>
                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id={`main-body-param-label-${idx}`}>
                                            {`Main Body Parameter ${idx + 1}`}
                                        </InputLabel>
                                        <Select 
                                            name={`${fieldName}_select`}
                                            labelId={`main-body-param-label-${idx}`}
                                            label={`Main Body Parameter ${idx + 1}`}
                                            value={value}
                                            onChange={e => handleSelectParamTypeChange(fieldName, e.target.value)}
                                        >
                                            {selectOptions.map(option => (
                                                <MenuItem key={option} value={option}>{option.toUpperCase()}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    {paramType === "custom" && 
                                        <TextField 
                                            fullWidth
                                            label={"Value"} 
                                            name={fieldName} 
                                            onChange={handleInputChange} 
                                        />
                                    }
                                </Grid>
                            </Grid>
                        );
                    }
                    // For header parameter
                    if (field.key === "hparameter" && field.key === fieldName) {
                        const paramType = value;
                        return (
                            <Grid container direction="row" spacing={2} key="hparameter" sx={{ marginBottom: 2 }}>
                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id="header-param-label">Header Parameter Type</InputLabel>
                                        <Select
                                            name="hparameter_select"
                                            value={value}
                                            labelId="header-param-label"
                                            label="Header Parameter Type"
                                            onChange={e => handleSelectParamTypeChange("hparameter", e.target.value)}
                                        >
                                            {selectOptions.map(option => (
                                                <MenuItem key={option} value={option}>{option.toUpperCase()}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    {paramType === "custom" && (
                                        <TextField
                                            fullWidth
                                            label="Value"
                                            name="hparameter"
                                            onChange={handleInputChange}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        );
                    }
                    return field;
                });
            });

    };

    // const handleInputChange = (event) => {
    //     const { name, value } = event.target;
    //     setFormValues(prev => ({
    //         ...prev,
    //         [name]: value,
    //         param_types: {
    //         ...(prev.param_types || {}),
    //         [name]: {
    //             name: name,
    //             param_type: paramTypes[name] || "custom",
    //             value: value
    //         }
    //         }
    //     }));
    // };

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        setFormValues(prev => {
            const paramType = prev.param_types?.[name]?.param_type || "custom";
            return {
            ...prev,
            [name]: value,
            param_types: {
                ...(prev.param_types || {}),
                [name]: {
                name: name,
                param_type: paramType,
                value: value
                }
            }
            };
        });
    };

    // const handleInputChange = (event) => {
    //     const { name, value } = event.target;
    //     console.log(`Input changed: ${name} = ${value}`);
        
    //     // Clone the current formValues to avoid reference issues
    //     setFormValues(prevFormValues => {
    //         const updatedFormValues = { ...prevFormValues };
    //         // Add or update the new value
    //         updatedFormValues[name] = value;

    //         // Initialize param_types as an object if not already
    //         if (typeof updatedFormValues.param_types !== 'object' || updatedFormValues.param_types === null || Array.isArray(updatedFormValues.param_types)) {
    //             updatedFormValues.param_types = {};
    //         }

    //         // Add or update the entry in param_types
    //         updatedFormValues.param_types[name] = { name: name, param_type: "custom", value: value };

    //         // updatedFormValues['param_types'] = {"param": name, "param_type": "custom"};
    //         console.log("Updated form values:", updatedFormValues);
    //         return updatedFormValues;
    //     });
    // };

    const handleSubmit = async (event) => {

        setLoading(true);  // Set loading to true before making API call

        if (event) event.preventDefault();
        if (selectedTemplate === '' || (mediaType !== 'none' && !mediaFile)) {
            setAlertObj({ active: true, type: "error", msg: "Media file not uploaded or template not selected" });
            setLoading(false);
            return;
        }

        // Check if all carousel media files are uploaded
        const requiredFieldsForTemplate = requiredFields[selectedTemplate] || [];
        const hasCarouselParams = requiredFieldsForTemplate.some(
            field => field.startsWith('cardimage') || field.startsWith('cardvideo')
        );

        if (hasCarouselParams) {
            // Extract required card indices
            const requiredCardIndices = requiredFieldsForTemplate
                .filter(field => field.startsWith('cardimage') || field.startsWith('cardvideo'))
                .map(field => {
                    const match = field.match(/_(\d+)$/);
                    return match ? parseInt(match[1]) : null;
                })
                .filter(index => index !== null);
            
            // Check if all required carousel files are uploaded
            const missingFiles = requiredCardIndices.filter(index => !carouselMediaFiles[index]);
            if (missingFiles.length > 0) {
                setAlertObj({ 
                    active: true, 
                    type: "error", 
                    msg: `Please upload media for Card${missingFiles.length > 1 ? 's' : ''} ${missingFiles.map(i => i + 1).join(', ')}` 
                });
                setLoading(false);
                return;
            }
        }

        const payload = new FormData();
        payload.append('template_json', JSON.stringify(templateData));
        
        // Append regular form values
        Object.keys(formValues).forEach(key => {
            // Skip empty values
            if (formValues[key] === undefined || formValues[key] === null || formValues[key] === '') {
                return;
            }
            
            // Log each parameter being added to payload
            console.log(`Adding parameter: ${key} = ${formValues[key]}`);
            
            // Special handling for body parameters to ensure correct format 
            if (key.startsWith('bparameter_')) {
                // Ensure bparameter values are correctly added with the right naming format
                payload.append(key, formValues[key]);
            } 
            // Check if this is a carousel parameter
            else if (key.startsWith('cardbodyparameter_') || key.startsWith('cardurlparameter_')) {
                // Extract card index from the key
                const match = key.match(/_(\d+)(?:_\d+)?$/);
                if (match) {
                    // Add the value with the correct parameter name format for the API
                    payload.append(key, formValues[key]);
                }
            } else {
                // Regular parameter
                payload.append(key, formValues[key]);
            }
        });

        if (formValues.param_types && Object.keys(formValues.param_types).length > 0) {
            payload.append('param_types', JSON.stringify(formValues.param_types));
        }
        
        // Append regular media file if present
        if (mediaFile) payload.append('file', mediaFile);

        // Append carousel media files if present
        if (Object.keys(carouselMediaFiles).length > 0) {
            Object.entries(carouselMediaFiles).forEach(([cardIndex, file]) => {
                payload.append(`carousel_file_${cardIndex}`, file);
            });
        }

        // Campaign option handling
        if (selectedCampaign === 'option1') {
            if (campaignName && csvFile) {
                payload.append('campaign_option', selectedCampaign);
                payload.append('campaign_name', campaignName);
                payload.append('campaign_description', campaignDescription);
                payload.append('csv_file', csvFile);
                payload.append('template_tracking', templateTracking);
            } else {
                if (!csvFile) {
                    setAlertObj({ active: true, type: "error", msg: "Please upload a CSV file" });
                    setLoading(false);
                    return;
                }
                setAlertObj({ active: true, type: "error", msg: "Please enter all the required fields" });
                setLoading(false);
                return;
            }
        } else if (selectedCampaign === 'option2') {
            if (campaignName && selectedSegment && phoneNumberCount > 0) {
                payload.append('campaign_option', selectedCampaign);
                payload.append('campaign_name', campaignName);
                payload.append('campaign_description', campaignDescription);
                payload.append('segment_name_list', JSON.stringify(selectedSegmentList));
                payload.append('template_tracking', templateTracking);
            } else {
                setAlertObj({ active: true, type: "error", msg: "Please enter all the required fields" });
                setLoading(false);
                return;
            }
        } else if (selectedCampaign === 'option3') {
            if (countryCode && dialCode && firstName && lastName) {
                payload.append('campaign_option', selectedCampaign);
                payload.append('country_code', countryCode);
                payload.append('dial_code', dialCode);
                payload.append('first_name', firstName);
                payload.append('last_name', lastName);
                payload.append('template_tracking', templateTracking);
            } else {
                setAlertObj({ active: true, type: "error", msg: "Please enter all required fields including first name, last name, and phone number" });
                setLoading(false);
                return;
            }
        }

        // Broadcast type handling
        if (broadcastType === 'one-time' || broadcastType === 'recurring') {
            // Add scheduling information to payload
            payload.append('broadcast_type', broadcastType);
            
            if (broadcastType === 'one-time') {
                const localDate = new Date(scheduleDate); // Ensure it's a Date object
                const localTime = new Date(broadcastTime).toLocaleTimeString('en-GB', {  
                    hour: '2-digit',  
                    minute: '2-digit',  
                    hour12: false  
                }); // Converts to HH:MM format in local timezone

                const formattedDate = localDate.toLocaleDateString('en-CA'); // YYYY-MM-DD
               
                payload.append('schedule_date', formattedDate);
                payload.append('broadcast_time', localTime);
                // payload.append('schedule_date', scheduleDate);
                // payload.append('broadcast_time', broadcastTime);
            }

            if ( broadcastType === 'recurring') {
                // Add recurring data to payload
                payload.append('repeat_interval', recurringData.repeatInterval);
                payload.append('monthly_pattern', recurringData.monthlyPattern);
                
                if (recurringData.monthlyPattern === 'dayOfMonth') {
                    payload.append('day_of_month', recurringData.dayOfMonth);
                } else {
                    payload.append('week_of_month', recurringData.weekOfMonth);
                    payload.append('day_of_week', recurringData.dayOfWeek);
                }
                
                payload.append('weekend_handling', recurringData.weekendHandling);
                
                // Format dates
                if (recurringData.startRecurrence) {
                    const startDate = new Date(recurringData.startRecurrence);
                    payload.append('start_recurrence', startDate.toLocaleDateString('en-CA')); // YYYY-MM-DD
                }
                
                if (!recurringData.noEndDate && recurringData.endRecurrence) {
                    const endDate = new Date(recurringData.endRecurrence);
                    payload.append('end_recurrence', endDate.toLocaleDateString('en-CA')); // YYYY-MM-DD
                }
                
                payload.append('no_end_date', recurringData.noEndDate ? true : false);
                
                // Add time
                if (broadcastTime) {
                    const time = new Date(broadcastTime);
                    const formattedTime = time.toLocaleTimeString('en-GB', {  
                        hour: '2-digit',  
                        minute: '2-digit',  
                        hour12: false  
                    });
                    payload.append('broadcast_time', formattedTime);
                }
            }
            
            payload.append('notify_before', notifyBefore ? true : false);
            payload.append('notify_status', notifyStatus ? true : false);
        }

        // Add debug log to check payload contents before submission
        for (let pair of payload.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        }

        const token = await getValidToken();
        const tenant = localStorage.getItem('tenant');

        console.log("payload: ", payload);

        try {
            const response = await axios.post(TEMPLATE_BROADCAST_ENDPOINT, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    "X-Tenant-Id": tenant
                },
            });
            if (broadcastType === 'one-time' || broadcastType === 'recurring') {
                setAlertObj({ active: true, type: "success", msg: "Broadcast has been scheduled successfully" });
            }
            else {
                setAlertObj({ active: true, type: "success", msg: "Broadcast Complete" });
            }
            setTimeout(() => {
                // Pass tab=1 parameter when redirecting for scheduled broadcasts
                if (broadcastType === 'one-time' || broadcastType === 'recurring') {
                    props.onNavigate('41', { tab: 1 });
                } else {
                    props.onNavigate('41');
                }
            }, 3000);
        } catch (error) {
             
            if (error.response.data.message && error.response.data.error_dict && error.response.data.error_dict.file) {
                const errorSummary = error.response.data.error_dict.file.error_summary || "File upload failed due to validation errors.";
                const errorDetails = error.response.data.error_dict.file.errors || [];
                setCSVError({ summary: errorSummary || "An error occurred.", details: errorDetails || [] });
              }
            else {
                setAlertObj({ active: true, type: "error", msg: `Broadcast Failed - ${error.response.status === 401 ? 'Unauthorized' : error.response.data.message}` });
            }
        }
        finally {
            setLoading(false);
          }
    };

    useEffect(() => {
        handleBroadcastTypeChange({ target: { value: broadcastType } });
    }, [broadcastType]);

    const handleCampaignClick = (event) => {
        event.preventDefault();
        
        // Check if media file is required but not uploaded
        if (mediaType !== 'none' && !mediaFile) {
            setAlertObj({ active: true, type: "error", msg: "Please upload the required media file" });
            return;
        }
        
        // Check if selectedTemplate is empty
        if (!selectedTemplate) {
            setAlertObj({ active: true, type: "error", msg: "Please select a template first" });
            return;
        }

        // Check if hparameter is empty
        if("hparameter" in formValues && formValues.hparameter.trim() === '') {
            setAlertObj({ active: true, type: "error", msg: "Please fill the header parameter" });
            return;
        }

        // Validation location coordinates
        if("locationparameter_latitude" in formValues && (formValues.locationparameter_latitude > 90 || formValues.locationparameter_latitude < -90)) {
            setAlertObj({ active: true, type: "error", msg: "Latitude must be between -90 and 90" });
            return;
        }

        if("locationparameter_longitude" in formValues && (formValues.locationparameter_longitude > 180 || formValues.locationparameter_longitude < -180)) {
            setAlertObj({ active: true, type: "error", msg: "Longitude must be between -180 and 180" });
            return;
        }

        console.log(JSON.stringify(formValues, null, 2));

        // Check if bparameters are empty
        const bparameterFields = Object.keys(formValues?.param_types).filter(key => key.startsWith('bparameter_'));
        if (bparameterFields.length !== 0 && bparameterFields.some(key => formValues?.param_types[key].value?.trim() === '')) {
            setAlertObj({ active: true, type: "error", msg: "Please fill the body parameters" });
            return;
        }

        // Check for required carousel media files
        const requiredFieldsForTemplate = requiredFields[selectedTemplate] || [];
        const hasCarouselParams = requiredFieldsForTemplate.some(
            field => field.startsWith('cardimage') || field.startsWith('cardvideo')
        );

        if (hasCarouselParams) {
            // Extract required card indices
            const requiredCardIndices = requiredFieldsForTemplate
                .filter(field => field.startsWith('cardimage') || field.startsWith('cardvideo'))
                .map(field => {
                    const match = field.match(/_(\d+)$/);
                    return match ? parseInt(match[1]) : null;
                })
                .filter(index => index !== null);
            
            // Check if all required carousel files are uploaded
            const missingFiles = requiredCardIndices.filter(index => !carouselMediaFiles[index]);
            if (missingFiles.length > 0) {
                setAlertObj({ 
                    active: true, 
                    type: "error", 
                    msg: `Please upload media for Card${missingFiles.length > 1 ? 's' : ''} ${missingFiles.map(i => i + 1).join(', ')}` 
                });
                return;
            }
        }
        
        if (event.target.checkValidity()) {
            setShowCampaignOptions(true);
        } else {
            event.target.reportValidity();
        }
    };

    const getFileInput = (type) => {
        const fileTypes = {
            image: {
                accept: '.jpg, .png',
                label: 'Choose .JPG or .PNG *',
            },
            video: {
                accept: '.mp4',
                label: 'Choose .MP4 file *',
            },
            document: {
                accept: '.pdf',
                label: 'Choose .PDF file *',
            },
        };

        if (fileTypes[type]) {
            const { accept, label } = fileTypes[type];
            return (
                <Grid container direction="column" spacing={2}>
                    <Grid item>
                        <input
                            ref={fileInputRef}
                            id="file-upload"
                            name="uploadedFile"
                            type="file"
                            accept={accept}
                            onChange={(e) => {
                                // Preserve form state during file upload
                                e.preventDefault();
                                handleMediaFileChange(e);
                            }}
                            style={{ display: 'none' }}
                            required
                        />
                        <label htmlFor="file-upload">
                            <Button
                                variant="contained"
                                component="span"
                                sx={{ marginTop: 1, marginBottom: 1 }}
                            >
                                {label}
                            </Button>
                        </label>
                    </Grid>
                </Grid>
            );
        }
        return null;
    };

    const FileUploadDetails = () => {
        if (!mediaFile && !mediaFileError) {
            return null;
        }

        return (
            <Grid container direction="column" spacing={1}>
                {/* Display file validation error */}
                {mediaFileError && (
                    <Grid item>
                        <Typography 
                            variant="body2" 
                            color="error" 
                            sx={{ display: 'block' }}
                        >
                            {mediaFileError}
                        </Typography>
                    </Grid>
                )}
                
                {/* Display file info if uploaded */}
                {mediaFile && (
                    <Grid item>
                        <Grid container alignItems="center" spacing={2}>
                            <Grid item>
                                <Typography variant="body2">
                                    File uploaded: {mediaFile.name}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <IconButton
                                    aria-label="delete"
                                    onClick={handleDeleteMediaFile}
                                    size="small"
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        );
    };

    const CarouselFileUploadDetails = ({ cardIndex, file, onDelete }) => {
        console.log("Invoked CarouselFileUploadDetails");


        if (!file) {
            return null;
        }
    
        return (
            <Grid container alignItems="center" spacing={2}>
                <Grid item>
                    <Typography variant="body2">
                        File uploaded: {file.name}
                    </Typography>
                </Grid>
                <Grid item>
                    <IconButton
                        aria-label="delete"
                        onClick={() => onDelete(cardIndex)}
                        size="small"
                    >
                        <DeleteIcon fontSize="small" />
                    </IconButton>
                </Grid>
            </Grid>
        );
    };

    const handleNextClick = () => {
        if (categoryFilter) {
            setShowTemplateSelection(true);
            // Clear any existing template selection
            setSelectedTemplate('');
            // Explicitly fetch data with the current category filter
            fetchTemplatesData();
        } else {
            setAlertObj({ active: true, type: "error", msg: "Please select a template type first" });
        }
    };

    const checkBroadcastButtonDisabled = () => {
        if (loading) {
            return true;
        }

        if (selectedCampaign === 'option2') {
            if (selectedSegmentList.length && phoneNumberCount === 0) {
                return true;
            }
        }
    }

    useEffect(() => {
        // Initial data fetch - should run only once when component mounts
        fetchTemplatesData();
        fetchCampaignsData();
    }, []);

    useEffect(() => {
        // fetchTemplatesData();
        // fetchCampaignsData();
        setRequiredFieldsToRender([...requiredFieldsToRender]);
    }, [mediaType, mediaFile, selectedTemplate, formValues, csvFile]);

    // TODO: Enable this when necessary its not necessary for broadcast
    // useEffect(() => {
    //     let timeoutId;
    //     if (alertObj.active) {
    //         timeoutId = setTimeout(handleAlertClose, 5000);
    //     }
    //     return () => clearTimeout(timeoutId);
    // }, [alertObj]);

    useEffect(() => {
        // Initial data fetch - should run only once when component mounts
        fetchTemplatesData();
    }, [categoryFilter]);

    useEffect(() => {
        console.log("formValues in useEffect before requiredFields: ", formValues);

        // This will force a re-render of the form fields when carouselMediaFiles or errors change
        if (selectedTemplate) {
            updateRequiredFields(selectedTemplate);
        }

        console.log("formValues in useEffect after requiredFields: ", formValues);
        
        console.log("carouselMediaFiles: ", carouselMediaFiles);

    }, [carouselMediaFiles, carouselFileErrors]);

    return (
        <Container maxWidth={false}>
            <div sx={{ padding: 2 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={8}>
                        <div sx={{ padding: 2 }}>
                            <form onSubmit={handleCampaignClick}>
                                <Typography variant="h6" sx={{ marginBottom: 1 }}>
                                    Select Broadcast Template Type
                                </Typography>
                                <Grid item xs={6}>
                                    <FormControl component="fieldset">
                                        <RadioGroup 
                                            row
                                            value={categoryFilter} 
                                            onChange={handleCategoryFilterChange}
                                        >
                                            <FormControlLabel value="marketing" control={<Radio />} label="Marketing" />
                                            <FormControlLabel value="utility" control={<Radio />} label="Utility" />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                                <Button 
                                    variant="contained" 
                                    onClick={handleNextClick}
                                    sx={{ mt: 1, mb: 1 }}
                                >
                                    Next
                                </Button>

                                {/* Select Template Section - Only show after category selection and Next button click */}
                                {showTemplateSelection && categoryFilter && (
                                    <>
                                        <Grid item xs={12}>
                                            <Typography variant="h6" sx={{ marginBottom: 1 }}>
                                                Select Template
                                            </Typography>
                                            <Autocomplete
                                                sx={{ width: '50%' }}
                                                options={templateOptions}
                                                value={selectedTemplate}
                                                onChange={(event, newValue) => handleTemplateChange({ target: { value: newValue || '' } })}
                                                renderInput={(params) => (
                                                    <TextField 
                                                        {...params} 
                                                        label="Select a template" 
                                                        variant="outlined"
                                                        required
                                                    />
                                                )}
                                                getOptionLabel={(option) => option}
                                                isOptionEqualToValue={(option, value) => option === value}
                                                noOptionsText="No templates found"
                                            />
                                            <Typography variant="body2" sx={{ marginTop: 1, color: 'gray' }}>
                                                Note: Only {categoryFilter} templates are available
                                            </Typography>
                                        </Grid>
                                    
                                    
                                        <Grid item xs={12} sx={{ marginTop: 2 }}>
                                            <FileUploadDetails />
                                        </Grid>

                                        {requiredFieldsToRender}
                                        
                                        <Button 
                                            variant="contained" 
                                            sx={{ marginTop: 2 }} 
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (mediaType !== 'none' && !mediaFile) {
                                                    setAlertObj({ active: true, type: "error", msg: "Please upload the required media file" });
                                                    return;
                                                }
                                                handleCampaignClick(e);
                                            }}
                                            type="submit"
                                        >
                                            Create Campaign
                                        </Button>
                                    </>
                                )}
                            </form>

                            {selectedTemplate && (
                                <form onSubmit={handleSubmit}>
                                    {showCampaignOptions && (
                                        <Grid container direction="column" sx={{ marginTop: 1 }}>
                                            <Divider sx={{ width: '100%', mt: 2 }} />
                                            
                                            <>
                                                <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                                                    Select Campaign Type:
                                                </Typography>
                                                <RadioGroup
                                                    value={selectedCampaign}
                                                    onChange={(e) => setSelectedCampaign(e.target.value)}
                                                >
                                                    <FormControlLabel value="option1" control={<Radio />} label="Upload Audience using CSV" />
                                                    <FormControlLabel value="option2" control={<Radio />} label="Send templates using segments" />
                                                    <FormControlLabel value="option3" control={<Radio />} label="Send template to a single contact" />
                                                </RadioGroup>
                                                <Divider sx={{ width: '100%', mt: 2 }} />
                                            </>
                                            {/* Add Broadcast Type Selection here */}
                                            {selectedCampaign && (
                                                <Grid item xs={12} sx={{ marginBottom: 2, marginTop: 2 }}>
                                                    <Typography variant="h6" sx={{ marginBottom: 1 }}>
                                                        Broadcast Type
                                                    </Typography>
                                                    <RadioGroup
                                                        row
                                                        value={broadcastType}
                                                        onChange={handleBroadcastTypeChange}
                                                    >
                                                        <FormControlLabel value="now" control={<Radio />} label="Now" />
                                                        <FormControlLabel value="one-time" control={<Radio />} label="One-time" />
                                                        <FormControlLabel value="recurring" control={<Radio />} label="Recurring" />
                                                    </RadioGroup>
                                                </Grid>
                                            )}
                                            
                                            {/* Only show campaign type options for "now" broadcast type */}
                                        </Grid>
                                    )}

                                    {/* <Divider sx={{ width: '100%', mt: 2 }} /> */}

                                    {selectedCampaign === 'option1' && (
                                        <UploadCSV 
                                            campaignName={campaignName}
                                            setCampaignName={setCampaignName}
                                            campaignDescription={campaignDescription}
                                            setCampaignDescription={setCampaignDescription}
                                            csvFile={csvFile}
                                            setCsvFile={setCsvFile}
                                            campaignsData={campaignsData}
                                        />
                                    )}

                                    {selectedCampaign === 'option2' && (
                                        <SelectSegment
                                            campaignName={campaignName}
                                            setCampaignName={setCampaignName}
                                            campaignDescription={campaignDescription}
                                            setCampaignDescription={setCampaignDescription}
                                            selectedSegment={selectedSegment}
                                            setSelectedSegment={setSelectedSegment}
                                            selectedSegmentList={selectedSegmentList}
                                            setSelectedSegmentList={setSelectedSegmentList}
                                            phoneNumberCount={phoneNumberCount}
                                            setPhoneNumberCount={setPhoneNumberCount}
                                            campaignsData={campaignsData}
                                        />
                                    )}

                                        {selectedCampaign === 'option3' && (
                                            <SingleContact
                                                setCountryCode={setCountryCode}
                                                setDialCode={setDialCode}
                                                setFirstName={setFirstName}
                                                setLastName={setLastName}
                                                // Pass current values from parent state
                                                firstNameValue={firstName}
                                                lastNameValue={lastName}
                                                countryCodeValue={countryCode}
                                                phoneNumberValue={dialCode}
                                            />
                                        )}

                                    {selectedCampaign && broadcastType === 'now' && (

                                        <>
                                            <Grid item xs={12} sx={{ marginBottom: 2, marginTop: 2 }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={templateTracking}
                                                            onChange={(e) => setTemplateTracking(e.target.checked)}
                                                        />
                                                    }
                                                    label="Update segment with customer response"
                                                />
                                            </Grid>

                                            <Button 
                                                variant="contained" 
                                                type="submit" 
                                                sx={{ marginTop: 2 }} 
                                                disabled={checkBroadcastButtonDisabled()}
                                            >
                                                {loading ? <CircularProgress size={24} /> : "Broadcast"} 
                                            </Button>
                                        </>
                                        
                                    )}
                                </form>
                            )}

                            {selectedTemplate && broadcastType === 'one-time' && (
                                <OneTimeBroadcast
                                    campaignName={campaignName}
                                    setCampaignName={setCampaignName}
                                    campaignDescription={campaignDescription}
                                    setCampaignDescription={setCampaignDescription}
                                    scheduleDate={scheduleDate}
                                    setScheduleDate={setScheduleDate}
                                    broadcastTime={broadcastTime}
                                    setBroadcastTime={setBroadcastTime}
                                    notifyBefore={notifyBefore}
                                    setNotifyBefore={setNotifyBefore}
                                    notifyStatus={notifyStatus}
                                    setNotifyStatus={setNotifyStatus}
                                    campaignsData={campaignsData}
                                    onCancel={handleCancelSchedule}
                                    onSubmit={handleSubmit}
                                    templateTracking={templateTracking}
                                    setTemplateTracking={setTemplateTracking}
                                    checkBroadcastButtonDisabled={checkBroadcastButtonDisabled}
                                />
                            )}

                            {selectedTemplate && broadcastType === 'recurring' && (
                                <RecurringBroadcast
                                    campaignName={campaignName}
                                    setCampaignName={setCampaignName}
                                    campaignDescription={campaignDescription}
                                    setCampaignDescription={setCampaignDescription}
                                    scheduleDate={scheduleDate}
                                    setScheduleDate={setScheduleDate}
                                    broadcastTime={broadcastTime}
                                    setBroadcastTime={setBroadcastTime}
                                    notifyBefore={notifyBefore}
                                    setNotifyBefore={setNotifyBefore}
                                    notifyStatus={notifyStatus}
                                    setNotifyStatus={setNotifyStatus}
                                    campaignsData={campaignsData}
                                    onCancel={handleCancelSchedule}
                                    onSubmit={handleSubmit}
                                    templateTracking={templateTracking}
                                    setTemplateTracking={setTemplateTracking}
                                    checkBroadcastButtonDisabled={checkBroadcastButtonDisabled}
                                    recurringData={recurringData}
                                    setRecurringData={setRecurringData}
                                />
                            )}
                            
                        </div>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        {templatePreviewData?.marketingOption && templatePreviewData.marketingOption === 'carousel' ? (
                            // Carousel template rendering
                            <MessageNode 
                                templateName={templatePreviewData.templateName}
                                language={templatePreviewData.language}
                                headerType="none"
                                headerText=""
                                headerFile={null}
                                body=""
                                sampleBodyFields={[]}
                                footer=""
                                mode='view'
                                allButtons={[]}
                                // Carousel-specific props
                                marketingOption="carousel"
                                carouselCards={templatePreviewData.carouselCards}
                                carouselMainBody={templatePreviewData.carouselMainBody}
                                carouselMainBodySampleFields={templatePreviewData.carouselMainBodySampleFields || []}
                                // Dynamically add all cardFile props from templatePreviewData with uploaded files overriding them
                                {...Object.keys(templatePreviewData)
                                    .filter(key => key.startsWith('cardFile_'))
                                    .reduce((acc, key) => {
                                        acc[key] = templatePreviewData[key];
                                        return acc;
                                    }, {})
                                }
                                // Then overlay the uploaded files (this will override any matching keys from above)
                                {...Object.keys(carouselMediaFiles).reduce((acc, index) => {
                                    acc[`cardFile_${index}`] = carouselMediaFiles[index];
                                    return acc;
                                }, {})}
                                // Force a key prop to ensure re-render when files change
                                key={`carousel-preview-${JSON.stringify(Object.keys(carouselMediaFiles))}`}
                            />
                        ) : (
                            // Regular template rendering (unchanged)
                            <MessageNode 
                                templateName={templatePreviewData?.template_name || ''}
                                language={templatePreviewData?.language || 'english'}
                                headerType={templatePreviewData?.headerType || 'none'}
                                headerText={templatePreviewData?.headerText || ''}
                                headerFile={mediaFile || templatePreviewData?.headerFile || null}
                                body={templatePreviewData?.body || 'No template selected'}
                                sampleBodyFields={templatePreviewData?.sampleBodyFields || []}
                                footer={templatePreviewData?.footer || ''}
                                allButtons={templatePreviewData?.allButtons || []}
                                mode='view'
                            />
                        )}
                    </Grid>
                </Grid>
                <Grid item xs={12} sx={{ marginTop: 2 }}>
                    {alertObj.active && (
                        <Alert severity={alertObj.type} onClose={handleAlertClose}>
                            {alertObj.msg}
                        </Alert>
                    )}
                    
                    {csvError && (
                            <Alert severity="error" sx={{ width: "100%" }} onClose={handleAlertClose}>
                            <Typography variant="body1" fontWeight="bold">
                                {csvError.summary}
                            </Typography>
                            {csvError.details.length > 0 && (
                                <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                {(showAllErrors ? csvError.details : csvError.details.slice(0, 5)).map((errMsg, index) => (
                                    <li key={index}>{errMsg}</li>
                                ))}
                                </ul>
                            )}
                            {csvError.details.length > 5 && (
                                <Typography
                                variant="body2"
                                sx={{ cursor: "pointer", color: "blue", textDecoration: "underline", mt: 1 }}
                                onClick={() => setShowAllErrors(!showAllErrors)}
                                >
                                {showAllErrors ? "Show less..." : "Read more..."}
                                </Typography>
                            )}
                            </Alert>
                        )}
                </Grid>
            </div>
            {/* <CarouselFileDisplayContainer 
                carouselMediaFiles={carouselMediaFiles}
                onDelete={handleDeleteCarouselMediaFile}
            /> */}
        </Container>
    );
};

export default React.memo(BroadcastTemplates);